<template>
  <div class="comparison-form-builder flex items-stretch">
    <template v-if="firstComparisonData">
      <!-- Sections only: -->
      <div class="comparison-form-builder__sections">
        <FormBuilder
          ref="firstFormBuilder"
          hide-form
          read-only-mode
          :data="firstComparisonData"
          @change:section="onSectionChange"
        />
      </div>

      <!-- Forms -->
      <div class="comparison-form-builder__wrapper py-4 w-full">
        <div class="comparison-form-builder__forms flex gap-5 px-3 flex-1 h-full overflow-y-auto scroll-bar">
          <div
            v-for="(data, index) in organizedComparisonData"
            :key="data.id || index"
            class="form-container flex flex-col flex-1 items-center pt-5 bg-white rounded-lg"
          >
            <DateBadge
              :date="data.date"
            />

            <FormBuilder
              ref="formBuilderList"
              class="flex-1 w-full"
              :data="data.form_data"
              hide-sections
              hide-navigation
              hide-disabled-controls
              read-only-mode
            />
          </div>
        </div>
      </div>
    </template>

    <div v-else class="flex items-center justify-center w-full h-full">
      <!-- TODO -->
    </div>
  </div>
</template>

<script>
// TODO higlight fields with different values

import FormBuilder from "@shared/components/form-builder/index.vue";
import DateBadge from "./components/DateBadge.vue";
import { organizeComparisonData } from "./utils";

export default {
  name: "FormBuilderComparison",

  components: {
    FormBuilder,
    DateBadge,
  },

  props: {
    /**
     * @description List of Form Builder data to be compared. All items must have the same structure.
     * 
     * @typedef {Object} ComparisonItem
     * @property {string} id - Unique identifier for the comparison item
     * @property {Object} form_data - Form builder data object containing sections, fields, and values // TODO
     * @property {string|Date} date - Date when the form data was created // TODO
     * 
     * @typedef {ComparisonItem[]} ComparisonList
     * @property {ComparisonList} comparisonData - Array of Form Builder data objects to compare.
     */
    comparisonData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      organizedComparisonData: null
    }
  },

  created() {
    this.organizedComparisonData = organizeComparisonData(this.comparisonData);
  },

  computed: {
    comparisonFormData() {
      if (!this.organizedComparisonData) return null;
      return this.organizedComparisonData.map((item) => item.form_data);
    },
    firstComparisonData() {
      return this.comparisonFormData[0] || null;
    },
    currentSectionId() {
      return this.$refs.firstFormBuilder?.selectedSectionId || null;
    },
    currentSection() {
      if (!this.firstComparisonData?.form_data?.sections) return null;
      return this.firstComparisonData.form_data.sections.find(
        (section) => section.id === this.currentSectionId
      );
    },
  },

  methods: {
    getRelatedSection(sectionIndex, formBuilder) {
      if (!formBuilder.getSections?.length) return null;
      return formBuilder.getSections[sectionIndex] || null;
    },
    getSectionIndex(section, sectionList) {
      if (!sectionList?.length) return null;
      return sectionList.findIndex((s) => s.section_id === section.section_id);
    },
    onSectionChange(section) {
      // can be stored to the component state if need to control the section from outside
      const selectedSectionIndex = this.getSectionIndex(section, this.firstComparisonData.sections);

      // search for the related section in FB-s mapped data
      this.$refs.formBuilderList.forEach((formBuilder) => {
        const relatedSection = this.getRelatedSection(selectedSectionIndex, formBuilder);
        if (!relatedSection) return;
        formBuilder.setCurrentSection(relatedSection);
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.comparison-form-builder {
  &__forms {
    ::v-deep {
      .neo-form-builder {
        height: 100%;
        display: flex;
        flex-direction: column;
        max-height: unset;
        overflow: visible;

        &__section {
          padding: 0;
          border: none;
          border-radius: 0;
          margin: 0;
        }
        
        &__content {
          max-height: unset;

          .builder-wrapper {
            flex: 1;
            overflow: visible;
            border-top-left-radius: 0;
            border-top-right-radius: 0;

            .dynamic-form-builder {
              height: 100%;
              
              &__body {
                overflow: visible;
                height: auto;
              }
            }
          }
        }
      }
    }
  }
}
</style>
